const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreCustomerManagementQuery: any = {
    searchCustomerByPhone: Backofficebff + '/v1/customer/get-global-customer-by-phone',
    searchCustomerBySsoId: Backofficebff + '/v1/customer/get-global-customer-by-sso-id',
};
